// Librairies
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

// Interfaces
export type SkeletonShape = 'bars' | 'line' | 'pie' | 'table' | 'heatmap' | 'kpi' | 'block';

// The skeleton of a graph type: the shape its data takes once loaded.
export function skeletonShape(graphType: string | null | undefined): SkeletonShape {
  const type = graphType ?? '';
  if (type === 'pie' || type === 'doughnut') return 'pie';
  if (/Line$|Area$/.test(type)) return 'line';
  if (type === 'table') return 'table';
  if (type === 'heatmap') return 'heatmap';
  if (['insight', 'text', 'weather'].includes(type)) return 'kpi';
  // A map, an image, a 3D view: one block.
  if (type.startsWith('geo') || ['projectMap', 'image', 'video', 'planning3D'].includes(type)) return 'block';
  return 'bars';
}

// The loading of a widget: over the whole widget, its skeleton (the title and the data to come as bones with a wave).
@Component({
  selector: 'app-widget-loading',
  standalone: true,
  templateUrl: './widget-loading.component.html',
  styleUrl: './widget-loading.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class WidgetLoadingComponent {
  // Variables
  @Input() set graphType(value: string | null | undefined) {
    this.shape = skeletonShape(value);
  }

  shape: SkeletonShape = 'bars';
  readonly bars: number[] = [45, 70, 55, 85, 40, 65, 75, 50];
  readonly rows: number[] = [1, 2, 3, 4, 5];
  readonly cells: number[] = Array.from({ length: 48 }, (_unused, index) => index);
}
